import React, { useEffect, useState } from "react";
import { callAPI, useStore, usePage, useUser } from "../../Utils/utils";
import { useNavigate } from "react-router-dom";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from "../../Components/Global/BreadCrumb/BreadCrumb";
import BlogList from "../../Components/Blog/BlogList/BlogList";
import Button from "../../Components/Global/Button";
import Pagination from "../../Components/Global/Pagination/Pagination";
import Loader from "../../Components/Global/Loader/Loader";
import { blog_page_labels } from "../../Constants/Labels";
import { select_store_message } from "../../Constants/Messages";

const BlogsPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { setPage } = usePage();
  const { store } = useStore();
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("all");
  const [searchValue, setSearchValue] = useState();
  const [searchResult, setSearchResult] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [payLoad, setPayLoad] = useState();
  const [storeName, setStoreName] = useState([]);
  const [resultInfo, setResultInfo] = useState({
    total_rows: "",
    fetched_rows: "",
    total_pages: "",
    page_size: 0,
    current_page: "",
    success: true,
    errors: "",
  });

  var store_id = store?.id;

  useEffect(() => {
    if (storeName?.length == 0 || storeName == undefined) {
      setStoreName(() => [store?.name]);
    } else {
      setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
    }
  }, [store?.id]);

  useEffect(() => {
    if (storeName[1] != undefined) {
      if (storeName[0] != storeName[1]) {
        navigate("/admin");
        setStoreName([]);
      }
    }
  }, [storeName]);

  useEffect(() => {
    setPage({ isLoading: loading });
  }, [loading, setPage]);

  useEffect(() => {
    var inital_pay_load = {
      store_id: store_id,
      status: mode,
      current_page: currentPage,
    };

    var pay_load = payLoad || inital_pay_load;
    if (pay_load.status !== mode) {
      pay_load.status = mode;
      pay_load.current_page = 1;
    }
    callAPI(
      "/admin/blog/by-store",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          token: user?.auth_token,
        },
        body: JSON.stringify(pay_load),
      },
      navigate,
      setLoading,
    ).then((data) => {
      if (data.success) {
        setSearchResult(data.records);
        setResultInfo({
          total_rows: data.total_rows,
          fetched_rows: data.fetched_rows,
          total_pages: data.total_pages,
          page_size: data.page_size,
          current_page: data.current_page,
          success: data.success,
          errors: data.errors,
        });
      }
    });
  }, [mode, store_id, payLoad, currentPage, navigate, user?.auth_token]);

  const onChangeSearchValue = (event) => {
    setSearchValue(event.target.value);
    var pay_load = {
      store_id: store_id,
      status: mode,
      current_page: 1,
    };
    if (event.target.value) {
      pay_load.filters = {
        conditions: [
          {
            field: "title",
            operator: "like",
            value: event.target.value,
            dataType: "string",
          },
        ],
      };
    }
    setPayLoad(pay_load);
  };

  const getSearchResult = (currentPageNum) => {
    var pay_load = {
      store_id: store_id,
      status: mode,
      current_page: currentPageNum || 1,
    };
    if (searchValue) {
      pay_load.filters = {
        conditions: [
          {
            field: "title",
            operator: "like",
            value: searchValue,
            dataType: "string",
          },
        ],
      };
    }
    setPayLoad(pay_load);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      getSearchResult(1);
    }
  };

  const onPageSelect = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  let select_store =
    store?.id == null ||
    store?.id === undefined ||
    store?.id === 0 ||
    store?.name === "Global Admin"
      ? true
      : false;
  let isSeparateStore = store?.is_separate_store === true;

  return (
    <Layout>
      <div className="breadcrumb-wrapper breadcrumb-contacts">
        <div className="d-flex flex-column">
          <BreadCrumb />
        </div>
        {store?.sub_domain != "glwd" && (
          <Button
            className={"btn btn-primary"}
            onClick={() => navigate("/admin/blog/new")}
            value={blog_page_labels?.blog_add_page_labels?.title}
          />
        )}
      </div>

      {select_store ? (
        <div className="ec-store-list card card-default">
          <div className="card-body  select_store">
            <p className="text-center">{select_store_message?.select_store}</p>
          </div>
        </div>
      ) : (
        <div className="cardWrapper card-default">
          <div className="card-body">
            <div className="table-responsive">
              <div className="dataTables_wrapper">
                <div className="filterTab mb-3">
                  <div className="navAndSearchWrapper">
                    <ul className="nav nav-tabs nav-style-border w-75">
                      <li
                        className="nav-item"
                        onClick={() => setMode("active")}
                      >
                        <span
                          className={`nav-link ${mode === "active" ? "active" : ""}`}
                        >
                          {blog_page_labels?.blog_page_tab_labels?.active}
                        </span>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() => setMode("inactive")}
                      >
                        <span
                          className={`nav-link ${mode === "inactive" ? "active" : ""}`}
                        >
                          {blog_page_labels?.blog_page_tab_labels?.inactive}
                        </span>
                      </li>
                      <li className="nav-item" onClick={() => setMode("all")}>
                        <span
                          className={`nav-link ${mode === "all" ? "active" : ""}`}
                        >
                          {blog_page_labels?.blog_page_tab_labels?.all}
                        </span>
                      </li>
                    </ul>

                    <div className="search-form">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={`${blog_page_labels?.blog_page_search_placeholder_label}`}
                          onChange={onChangeSearchValue}
                          onKeyDown={handleKeyDown}
                        />
                        <span className="search_icon">
                          <i className="mdi mdi-magnify"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {loading && <Loader className={"table_loader"} />}

                <BlogList
                  mode={mode}
                  searchResult={searchResult}
                  loader={loading}
                />
                <div className="paginationWrapper">
                  <Pagination
                    totalRows={resultInfo.total_rows}
                    fetchedRows={resultInfo.fetched_rows}
                    totalPages={resultInfo.total_pages}
                    pageSize={resultInfo.page_size}
                    currentPage={resultInfo.current_page}
                    onPageSelect={onPageSelect}
                    label={blog_page_labels?.blog_page_pagination_label}
                    loader={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};
export default BlogsPage;
